function getDateOneMonthBeforeToday() {
    const currentDate = new Date();
    currentDate.setMonth(currentDate.getMonth() - 1);
    return currentDate;
}

export default getDateOneMonthBeforeToday;
